import React, { useEffect, useState } from 'react';
import { withWrapper } from '@shared/react';
import {
    TradeOrderDetailTableProvider,
    useClientDetailsTable,
    getTradeOrderDetailTableColumns,
    UserManagement_TABLE_INFO_URL,
} from './lib';
import { Table } from '@features/Table';
import './TradeOrderDetailTable.scss';
import { Loader } from '@shared/UI';
import { getTradeOrderByJobId, updateTradeOrder } from '@pages/Preferences/api';
import { useNotify } from '@features/Notify';
import { FaHand } from 'react-icons/fa6';
import { FaCheck } from 'react-icons/fa';
import { getTradeOrder } from './api';

interface TradeOrderDetailTableContentProps {
    orderId: any;
}

const TradeOrderDetailTableContent: React.FC<TradeOrderDetailTableContentProps> = ({ orderId }) => {
    const { AssignPositionBody, paginationOptions, setOrderId, portfolioLoading } = useClientDetailsTable();
    const [tradeOrder, setTradeOrder] = useState<any>();
    const userStorage = localStorage.getItem('User');
    const userObject: any = userStorage ? JSON.parse(userStorage) : null;
    const notify = useNotify();
    const [refreshKey, setRefreshKey] = useState(0);

    useEffect(() => {
        if ((orderId === 0 || orderId) && !orderId.includes('req')) {
            setOrderId(orderId);
            (async () => {
                const result = await getTradeOrderByJobId(orderId);
                setTradeOrder(result);
            })();
        } else {
            setOrderId(orderId);
            (async () => {
                const cleanOrderId = orderId.replace('req', '');
                const { tradeOrders, totalCount } = await getTradeOrder(parseFloat(cleanOrderId));
                setTradeOrder(tradeOrders ? tradeOrders[0] : null);
            })();
        }
    }, [orderId, setOrderId, refreshKey]);

    const heldTradeOrder = async () => {
        try {
            const updatedOrder = {
                ...tradeOrder,
                handledByUserId: userObject.id,
                tradeOrderStatus: 'Held',
                heldedByUser: null,
                rebalancingJob: null,
                ria: null,
            };
            const result = await updateTradeOrder(updatedOrder);
            setRefreshKey((prev) => prev + 1);
            notify.success(result);
        } catch (error) {
            notify.error('Failed to update trade order');
        }
    };

    const completeTradeOrder = async () => {
        try {
            const updatedOrder = {
                ...tradeOrder,
                handledByUserId: userObject.id,
                tradeOrderStatus: 'Completed',
                heldedByUser: null,
                rebalancingJob: null,
                ria: null,
            };
            const result = await updateTradeOrder(updatedOrder);
            setRefreshKey((prev) => prev + 1);
            notify.success(result);
        } catch (error) {
            notify.error('Failed to update trade order');
        }
    };

    if (portfolioLoading) {
        return <Loader />;
    }

    return (
        <div>
            {tradeOrder && (
                <div className='trade-order-detial-header'>
                    <div className='client-name-trade-order'>
                        {' '}
                        {AssignPositionBody[0]?.job?.user?.firstName} {AssignPositionBody[0]?.job?.user?.lastName}{' '}
                    </div>
                    <div className='trade-order-actions'>
                        {tradeOrder?.tradeOrderStatus === 'Held' && userObject.id !== tradeOrder?.handledByUserId && (
                            <div className='held-by-name'>
                                {' '}
                                <FaHand /> Held by {tradeOrder?.heldedByUser?.firstName}{' '}
                                {tradeOrder?.heldedByUser?.lastName}
                            </div>
                        )}
                        {tradeOrder?.tradeOrderStatus === 'Completed' && (
                            <div className='completed-by-name'>
                                {' '}
                                <FaCheck /> Completed by {tradeOrder?.heldedByUser?.firstName}{' '}
                                {tradeOrder?.heldedByUser?.lastName}
                            </div>
                        )}
                        {tradeOrder?.tradeOrderStatus !== 'Held' && tradeOrder?.tradeOrderStatus !== 'Completed' && (
                            <>
                                {' '}
                                <button
                                    className='hold-button-table primary'
                                    onClick={() => heldTradeOrder()}
                                >
                                    Hold
                                </button>
                                <button
                                    className='hold-button secondary'
                                    onClick={() => completeTradeOrder()}
                                >
                                    Complete
                                </button>{' '}
                            </>
                        )}
                        {tradeOrder?.tradeOrderStatus === 'Held' && userObject.id === tradeOrder?.handledByUserId && (
                            <>
                                {' '}
                                <button
                                    className='hold-button secondary'
                                    onClick={() => completeTradeOrder()}
                                >
                                    Complete
                                </button>
                            </>
                        )}
                    </div>
                </div>
            )}
            {tradeOrder && (
                <Table
                    columns={getTradeOrderDetailTableColumns()}
                    data={AssignPositionBody}
                    tableTitle={undefined}
                    infoLink={UserManagement_TABLE_INFO_URL}
                    paginationOptions={paginationOptions}
                    filters={undefined}
                    row={undefined}
                    noScroll={true}
                />
            )}
        </div>
    );
};

export const TradeOrderDetailTable = withWrapper(TradeOrderDetailTableProvider)(TradeOrderDetailTableContent);
